module.exports = __webpack_public_path__ + "media/images/common/right_product_box_bg-0881ed28bda47a32d72d1b6d18c0b2d4.png";